import { Component, Input, OnInit } from "@angular/core";
import { IVTableColumn } from "@app/directives/_layout/v-table/_models/IVTableColumn";
import { IVTableRow } from "@app/directives/_layout/v-table/_models/IVTableRow";
import { FallbackCellType, VTableService } from "@app/directives/_layout/v-table/_services/v-table.service";
import { IAggregateFilterEvent } from "@app/directives/_resourceFilters/filter-bar/filter-bar.models";
import { DateRange } from "@app/enum/DateRange.enum";
import { SortDirection } from "@app/enum/SortDirection";
import { SortType } from "@app/enum/SortType";
import { ISensorData } from "@app/interfaces/ISensorData";
import { DateService } from "@app/services/date.service";
import { IVehicleWithSensorDataValues } from "../../_models/IVehicleWithSensorData";
import { SensorDataService } from "../../sensor-data.service";
import "./sensor-data-history.component.scss";

// TODO: this is workaround for filter-bar to work.
// can be removed when https://dev.azure.com/Connexas/Valkyrie/_git/Valkyrie/pullrequest/8849
// is present on master branch
interface IIdSensorData extends ISensorData {
    Id: number;
}

@Component({
    selector: 'sensor-data-history',
    template: require("./sensor-data-history.component.html")
})
export class SensorDataHistoryComponent implements OnInit {
    @Input() vehicle: IVehicleWithSensorDataValues

    tableColumns: IVTableColumn<IIdSensorData>[] = [];
    tableRows: IVTableRow<IIdSensorData>[] = [];

    defaultDateRange = DateRange.Today;
    startDate: Date;
    endDate: Date;

    sensorData: IIdSensorData[] = [];
    loading: boolean;

    constructor(
        private readonly vTableService: VTableService,
        private readonly sensorDataService: SensorDataService,
        private readonly dateService: DateService
    ) { }

    async ngOnInit(): Promise<void> {
        this.startDate = this.dateService.dateRangeFromEnum(this.defaultDateRange).start;
        this.endDate = this.dateService.dateRangeFromEnum(this.defaultDateRange).end;

        this.createTableColumns();
    }

    async onFilterChanged(filterEvent: IAggregateFilterEvent<ISensorData>): Promise<void> {
        if (filterEvent.trigger == "date") {
            this.startDate = filterEvent.date[0];
            this.endDate = filterEvent.date[1];

            await this.loadSensorData();
        }
    }

    private createTableColumns(): void {
        this.tableColumns = [
            {
                header: this.vTableService.createDateTableHeader({
                    tKey: "SensorData.Timestamp",
                    sortable: true,
                    sortDirection: SortDirection.Descending,
                    sorted: true
                }),
                createCellFunction: (data) => this.vTableService.createDateCell(data.Utc)
            },
            {
                header: this.vTableService.createTableHeader({
                    tKey: "SensorData.EngineHoursTotal",
                    sortType: SortType.Number,
                    sortable: true
                }),
                createCellFunction: (data) => this.vTableService.createTableCell(this.getEngineHours(data), {}, FallbackCellType.NA)
            }
        ]
    }

    private createTableRows(): void {
        this.tableRows = this.vTableService.createTableRows(this.sensorData, this.tableColumns);
    }

    private getEngineHours(data: ISensorData): number {
        return data.PrimaryAuxEngineOnDuration ? data.PrimaryAuxEngineOnDuration / 3600 : null;
    }

    private async loadSensorData(): Promise<void> {
        this.loading = true;

        const result = await this.sensorDataService.getSensorData(this.vehicle.Id, this.startDate, this.endDate);

        this.sensorData = result.map(x => ({ ...x, Id: x.PlotId } as IIdSensorData))
        this.createTableRows();
        this.loading = false;
    }
}
